import React from 'react';
//import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';


import { AuthProvider, useAuth } from './components/AuthProvider';
import { ProtectedRoute } from './components/ProtectedRoute';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import Screen from './components/screen';
//Unit I

import ScreenI from './components/Comp/Sugar/UnitI/screenI';
import DataScreenI from './components/Comp/Sugar/UnitI/DataScreenI';
import VehI from './components/Comp/Sugar/UnitI/vehI';
import CrushingI from './components/Comp/Sugar/UnitI/crushingI';
import LabanaI from './components/Comp/Sugar/UnitI/labanaI';
import EstimatedAGI from './components/Comp/Sugar/UnitI/EstimatedAGI';
import StockI from './components/Comp/Sugar/UnitI/stockI';
import SugarCostI from './components/Comp/Sugar/UnitI/sugarcostI';
import ElpregistrationdateI from './components/Comp/Sugar/UnitI/elpregistrationdateI';
import ElpregistrationwayI from './components/Comp/Sugar/UnitI/elpregistrationwayI';
import AgAsI from './components/Comp/Sugar/UnitI/AgAsI';
import ScAnalysisI from './components/Comp/Sugar/UnitI/scAnalysisI';
import FlowI from './components/Comp/Sugar/UnitI/flowI';


//Unit II

import EstimatedAG from './components/EstimatedAG';
import DataScreen from './components/DataScreen';
import AgAs from './components/AgAs';
import Login from './components/Login';
import Crushing from './components/crushing';
import StockInProcess from './components/stock';
import Labana from './components/labana';
import SugarCost from './components/sugarcost';
//import VehicleList from './components/VehicleList';
import Veh from './components/veh';
import Elpregistrationdate from './components/elpregistrationdate';
import Flow from './components/flow';
import Elpregistrationway from './components/elpregistrationway';
import ScAnalysis from './components/scAnalysis';



function App() {
  return (
    
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/Login" element={<LoginWrapper />} />

          {/* Protected Routes */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AuthenticatedApp />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

// Wrapper for Login to demonstrate login functionality
function LoginWrapper() {
  const { login } = useAuth();
  return <Login onLogin={login} />;
}

// Protected App Layout
function AuthenticatedApp() {
  const { logout } = useAuth();

  return (
    <div className="d-flex">
    
      <div className="flex-grow-1">
        <Header onLogout={logout} />
        <div className="container-fluid p-4">
          <Routes>
            <Route path="/" element={<Dashboard />} />
             {/*Uni I*/}
            <Route path="/ScreenI" element={<ScreenI />} />
            <Route path="/DataScreenI" element={<DataScreenI />} />
            <Route path="/vehI" element={<VehI />} />
            <Route path="/CrushingI" element={<CrushingI />} />
            <Route path="/LabanaI" element={<LabanaI />} />
            <Route path="/EstimatedAGI" element={<EstimatedAGI />} />
            <Route path="/StockI" element={<StockI />} />
            <Route path="/ELPRegistrationDateI" element={<ElpregistrationdateI />} />
            <Route path="/ELPRegistrationwayI" element={<ElpregistrationwayI />} />
            <Route path="/AgAsI" element={<AgAsI />} />
            <Route path="/scAnalysisI" element={<ScAnalysisI />} />
            <Route path="/FlowI" element={<FlowI />} />

            <Route path="/SugarCostI" element={<SugarCostI />} />

          {/*Unit II*/}
            <Route path="/Screen" element={<Screen />} />
          
            <Route path="/DataScreen" element={<DataScreen />} />
            <Route path="/EstimatedAG" element={<EstimatedAG />} />
            <Route path="/AgAs" element={<AgAs />} />
            <Route path="/Crushing" element={<Crushing />} />
            <Route path="/Stock" element={<StockInProcess />} />
            <Route path="/Labana" element={<Labana />} />
            <Route path="/SugarCost" element={<SugarCost />} />
            {/* <Route path="/VehicleList" element={<VehicleList />} /> */}
            <Route path="/veh" element={<Veh />} />
            <Route path="/ELPRegistrationDate" element={<Elpregistrationdate />} />
            <Route path="/flow" element={<Flow />} />
           
            <Route path="/elpregistrationway" element={<Elpregistrationway />} />
            <Route path="/ScAnalysis" element={<ScAnalysis />} />

          
           
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default App;
